import HomeSlider from './home-slider';

const Hero = () => (
  <div>
    <HomeSlider />
  </div>
);
export default Hero;
